import { utcToZonedTime } from 'date-fns-tz';

import { blobClient } from '@api/client';
import { URL } from '@api/urls';

import { formatDate } from '@utils/kpi-utils/date';

import { IExportDefaultDTO } from '@interfaces/common/defaultDTO';

import { EAlarmStatus } from '@enums/alarms';

import { formatTemplateDefault, timezoneUTC } from '@constants/common';

const {
	exportAlarmHistory,
	alarmOranExport,
	exportActiveAlarmsFlexidas,
	exportAlarmHistoryFlexidas,
	alarmOranHistoryExport,
} = URL;

export const getExportOranAlarmFile = (dto: IExportDefaultDTO): Promise<IExportDefaultDTO> => {
	return blobClient.post(alarmOranExport, dto);
};

export const getExportOranHistoryAlarmFile = (dto: IExportDefaultDTO): Promise<IExportDefaultDTO> => {
	return blobClient.post(alarmOranHistoryExport, dto);
};

export const getExportAlarmFile = (dto: IExportDefaultDTO): Promise<IExportDefaultDTO> => {
	const fromText = dto?.filter?.from
		? formatDate(utcToZonedTime(dto.filter.from, timezoneUTC), formatTemplateDefault)
		: null;
	const toText = dto?.filter?.to
		? formatDate(utcToZonedTime(dto.filter.to, timezoneUTC), formatTemplateDefault)
		: null;

	return blobClient.post(exportAlarmHistory, {
		...dto,
		filter: {
			...dto.filter,
			status: EAlarmStatus.active,
			fromText,
			toText,
		},
	});
};

export const getExportAlarmHistoryFile = (dto: IExportDefaultDTO): Promise<IExportDefaultDTO> => {
	const fromText = dto?.filter?.from
		? formatDate(utcToZonedTime(dto.filter.from, timezoneUTC), formatTemplateDefault)
		: null;
	const toText = dto?.filter?.to
		? formatDate(utcToZonedTime(dto.filter.to, timezoneUTC), formatTemplateDefault)
		: null;

	return blobClient.post(exportAlarmHistory, {
		...dto,
		filter: {
			...dto.filter,
			fromText,
			toText,
		},
	});
};

export const getExportActiveAlarmsFlexidas = (dto: IExportDefaultDTO): Promise<IExportDefaultDTO> => {
	const fromText = dto?.filter?.from
		? formatDate(utcToZonedTime(dto.filter.from, timezoneUTC), formatTemplateDefault)
		: null;
	const toText = dto?.filter?.to
		? formatDate(utcToZonedTime(dto.filter.to, timezoneUTC), formatTemplateDefault)
		: null;

	return blobClient.post(exportActiveAlarmsFlexidas, {
		...dto,
		filter: {
			...dto.filter,
			fromText,
			toText,
		},
	});
};

export const getExportAlarmHistoryFlexidas = (dto: IExportDefaultDTO): Promise<IExportDefaultDTO> => {
	const fromText = dto?.filter?.from
		? formatDate(utcToZonedTime(dto.filter.from, timezoneUTC), formatTemplateDefault)
		: null;
	const toText = dto?.filter?.to
		? formatDate(utcToZonedTime(dto.filter.to, timezoneUTC), formatTemplateDefault)
		: null;

	return blobClient.post(exportAlarmHistoryFlexidas, {
		...dto,
		filter: {
			...dto.filter,
			fromText,
			toText,
		},
	});
};
